import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './append';
import 'intersection-observer';
import 'intl';
import 'intl/locale-data/jsonp/en-GB';
import 'intl/locale-data/jsonp/en-US';
import 'intl/locale-data/jsonp/en';
import 'url-search-params-polyfill';
import 'whatwg-fetch';
import cssVars from 'css-vars-ponyfill';
import 'loading-attribute-polyfill';

cssVars();
